import {absurd} from './helpers/absurd';
import {initializeAuthenticationReturnMode} from './AuthenticationReturnMode';
import {initializeFinancialPartnerPayButtonMode} from './PartnerPayButton';

const INITIALIZATION_MODES = [
  'pay_button',
  'authentication_return',
  'loading',
] as const;
export type FinancialPartnerAppMode = (typeof INITIALIZATION_MODES)[number];

const getInitializationModeFromQuery = (): FinancialPartnerAppMode => {
  const params = new URLSearchParams(window.location.search);
  const maybeUrlMode = params.get('mode');
  const maybeFoundMode = INITIALIZATION_MODES.find(
    (mode) => mode === maybeUrlMode,
  );
  return maybeFoundMode || 'pay_button';
};

export const initializeAppContainerElement = () => {
  const appContainerElem = document.createElement('div');
  appContainerElem.id = 'financial-partner-app-container';
  appContainerElem.className = 'financial-partner-app-container';
  document.body.appendChild(appContainerElem);

  return appContainerElem;
};

export const initializeFinancialPartnerApp = (args: {
  partnerExpressUrl: string;
}): void => {
  initializeAppContainerElement();
  const initializationMode = getInitializationModeFromQuery();
  switch (initializationMode) {
    case 'pay_button':
      initializeFinancialPartnerPayButtonMode({...args});
      break;
    case 'loading':
    case 'authentication_return':
      // Both loading and authentication return mode do nothing but
      // produce a loading spinner. So they get the same treatment.
      initializeAuthenticationReturnMode();
      break;
    default:
      absurd(
        initializationMode,
        `Unexpected initialization mode ${initializationMode}`,
      );
  }
};
